import React, { useState } from 'react';
import { Volume2, VolumeX, Loader } from 'lucide-react';

const TextToSpeechButton = ({ text, language = 'en', size = 24, className = '' }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [audio, setAudio] = useState(null);

  const playAudio = async () => {
    if (isPlaying && audio) {
      // Stop current audio
      audio.pause();
      audio.currentTime = 0;
      setIsPlaying(false);
      return;
    }

    setIsLoading(true);
    try {
      const token = localStorage.getItem('token');
      const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

      const response = await fetch(`${BACKEND_URL}/api/voice/text-to-speech`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          text: text,
          language: language
        })
      });

      if (!response.ok) {
        throw new Error('Text-to-speech failed');
      }

      const data = await response.json();
      
      // Create audio from base64
      const audioBlob = await fetch(`data:audio/mp3;base64,${data.audio_base64}`).then(r => r.blob());
      const audioUrl = URL.createObjectURL(audioBlob);
      const audioElement = new Audio(audioUrl);

      audioElement.onended = () => {
        setIsPlaying(false);
        URL.revokeObjectURL(audioUrl);
      };

      audioElement.onerror = () => {
        setIsPlaying(false);
        setIsLoading(false);
        alert('Failed to play audio');
      };

      setAudio(audioElement);
      await audioElement.play();
      setIsPlaying(true);
    } catch (error) {
      console.error('TTS error:', error);
      alert('Failed to convert text to speech. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={playAudio}
      disabled={isLoading || !text}
      data-testid="text-to-speech-button"
      className={`flex items-center justify-center p-2 rounded-full transition-all ${
        isPlaying
          ? 'bg-[#F59E0B] text-black'
          : 'bg-[#0F4C81] text-white hover:bg-[#0d3d6b]'
      } disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
      title={isPlaying ? 'Stop Audio' : 'Read Aloud'}
    >
      {isLoading ? (
        <Loader className="animate-spin" size={size} />
      ) : isPlaying ? (
        <VolumeX size={size} />
      ) : (
        <Volume2 size={size} />
      )}
    </button>
  );
};

export default TextToSpeechButton;
